import { DateTime } from "luxon";

export function dateFormat(inputDate, format) {
    /* Date format details.
     * MMMM = November
     * MMM = Nov
     * MM = 11
     * dd = 31
     * yyyy = 2022
     * yy = 22
     */
    // parse the input date
    const date = new Date(inputDate);

    // extract the parts of the date
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    // replace the month
    if (format.indexOf("MMMM") > -1) {
        // replace the long month
        const longMonth = date.toLocaleString('default', { month: 'long' });
        format = format.replace("MMMM", longMonth);
    } else if (format.indexOf("MMM") > -1) {
        // replace the short month
        const shortMonth = date.toLocaleString('default', { month: 'short' });
        format = format.replace("MMM", shortMonth);
    } else {
        format = format.replace("MM", month.toString().padStart(2, "0"));
    }

    // replace the year
    if (format.indexOf("yyyy") > -1) {
        format = format.replace("yyyy", year.toString());
    } else if (format.indexOf("yy") > -1) {
        format = format.replace("yy", year.toString().substr(2, 2));
    }

    // replace the day
    format = format.replace("dd", day.toString().padStart(2, "0"));
    return format;
}

export function dateTimeFormat(inputDate, format) {
    /* Date format details.
     * MMMM = November
     * MMM = Nov
     * MM = 11
     * dd = 31
     * yyyy = 2022
     * yy = 22
     * HH = 12
     * mm = 60
     * tt = AM or PM
     */
    // parse the input date
    const date = new Date(inputDate);

    // extract the parts of the date
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    var hour = date.getHours();
    const minute = date.getMinutes();
    const amOrPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;

    // replace the month
    if (format.indexOf("MMMM") > -1) {
        // replace the long month
        const longMonth = date.toLocaleString('default', { month: 'long' });
        format = format.replace("MMMM", longMonth);
    } else if (format.indexOf("MMM") > -1) {
        // replace the short month
        const shortMonth = date.toLocaleString('default', { month: 'short' });
        format = format.replace("MMM", shortMonth);
    } else {
        format = format.replace("MM", month.toString().padStart(2, "0"));
    }

    // replace the year
    if (format.indexOf("yyyy") > -1) {
        format = format.replace("yyyy", year.toString());
    } else if (format.indexOf("yy") > -1) {
        format = format.replace("yy", year.toString().substr(2, 2));
    }

    // replace the hour
    if (format.indexOf("HH") > -1) {
        format = format.replace("HH", hour.toString().padStart(2, "0"));
    }

    // replace the minutes
    if (format.indexOf("mm") > -1) {
        format = format.replace("mm", minute.toString().padStart(2, "0"));
    }

    // replace the minutes
    if (format.indexOf("tt") > -1) {
        format = format.replace("tt", amOrPm);
    }

    // replace the day
    format = format.replace("dd", day.toString().padStart(2, "0"));
    return format;
}

export function dateFormat_dr(inputDate, format) {
    /* Date format details.
     * MMMM = November
     * MMM = Nov
     * MM = 11
     * dd = 31
     * yyyy = 2022
     * yy = 22
     */
    // parse the input date
    //const date = new Date(inputDate);
    const [day, month, year] = inputDate.split("-").map(Number);
    const date = new Date(year, month - 1, day); // month is zero-based


    if (format.indexOf("MMMM") > -1) {
        // replace the long month
        const longMonth = date.toLocaleString('default', { month: 'long' });
        format = format.replace("MMMM", longMonth);
    } else if (format.indexOf("MMM") > -1) {
        // replace the short month
        const shortMonth = date.toLocaleString('default', { month: 'short' });
        format = format.replace("MMM", shortMonth);
    } else {
        format = format.replace("MM", month.toString().padStart(2, "0"));
    }

    // replace the year
    if (format.indexOf("yyyy") > -1) {
        format = format.replace("yyyy", year.toString());
    } else if (format.indexOf("yy") > -1) {
        format = format.replace("yy", year.toString().substr(2, 2));
    }

    // replace the day
    format = format.replace("dd", day.toString().padStart(2, "0"));
    return format;
}

export function getCurrentFinancialYear() {
    var fiscalyear = "";
    var today = new Date();
    if ((today.getMonth() + 1) <= 3) {
        fiscalyear = (today.getFullYear() - 1) + "-" + today.getFullYear()
    } else {
        fiscalyear = today.getFullYear() + "-" + (today.getFullYear() + 1)
    }
    return fiscalyear
}

export function getFinancialYear(date) {
    const givenDate = new Date(date);
    const year = givenDate.getFullYear();
    const month = givenDate.getMonth(); // Month is 0-based

    // Financial year starts from April 1st
    const startOfFinancialYear = new Date(year, 3, 1); // April is 3
    const endOfFinancialYear = new Date(year + 1, 2, 31); // March is 2

    if (givenDate < startOfFinancialYear) {
        return `${year - 1}-${year}`;
    } else {
        return `${year}-${year + 1}`;
    }
}

export function addCurrentTimeToDate(date) {
    const nowInIndia = DateTime.now().setZone("Asia/Kolkata").toFormat('HH:mm:ss');
    return `${date}T${nowInIndia}`;
}

export function getISTCurrentDate() {
    return DateTime.now().setZone("Asia/Kolkata").toFormat('dd-MM-yyyy');
}

export function getISTCurrentDateTime() {
    return DateTime.now().setZone("Asia/Kolkata").toFormat('dd-MM-yyyy HH:mm:ss');
}


export function formatDateToISO(dateStr) {
    if (typeof (dateStr) == "string") {
        const [day, month, year] = dateStr?.split("-");
        return `${year}-${month}-${day}`;
    }

    let date;
    if (Array.isArray(dateStr) && dateStr.length > 0) {
        dateStr = dateStr[0];
        date = new Date(dateStr);
        if (isNaN(date.getTime())) {
            throw new Error("Invalid date format");
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    if (typeof (dateStr) == "object") {
        date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }
};

export function formatDateToISODate(dateStr) {
    if (typeof (dateStr) == "string") {
        const [day, month, year] = dateStr?.split("-");
        return `${year}-${month}-${day}`;
    }

    let date;
    date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

export function sortingCss(sortColumn, column) {
    var css = "";
    if (column.disableSorting != true) {
        css = localStorage.getItem("SortOrder") == "ASC" ? 'sorting_asc' : localStorage.getItem("SortOrder") == "DESC" ? 'sorting_desc' : 'sorting_defalut';
        css = sortColumn == column.id ? css : 'sorting_defalut';
        css += " cursor-pointer";
    }
    return css;
}


export function dateTimeFormatIOS1(inputDate) {
    const date = new Date(inputDate);
    return date.toISOString(); // returns UTC time in format: "2025-04-04T12:02:43.448Z"
}

export function dateTimeFormatIOS(inputDate) {
    const date = new Date(inputDate);

  // Get the time in IST using toLocaleString
  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  const parts = formatter.formatToParts(date).reduce((acc, part) => {
    if (part.type !== 'literal') acc[part.type] = part.value;
    return acc;
  }, {});

  const yyyy = parts.year;
  const MM = parts.month;
  const dd = parts.day;
  const HH = parts.hour;
  const mm = parts.minute;
  const ss = parts.second;

  // Add milliseconds and offset manually
  const ms = String(date.getMilliseconds()).padStart(3, '0');

  return `${yyyy}-${MM}-${dd}T${HH}:${mm}:${ss}.${ms}`;
}


export function dateTimeFormat1(inputDate, format) {
    const date = new Date(inputDate);

    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    let hour = date.getUTCHours();
    const minute = date.getUTCMinutes();
    const amOrPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;

    if (format.indexOf("MMMM") > -1) {
        const longMonth = date.toLocaleString('default', { month: 'long', timeZone: 'UTC' });
        format = format.replace("MMMM", longMonth);
    } else if (format.indexOf("MMM") > -1) {
        const shortMonth = date.toLocaleString('default', { month: 'short', timeZone: 'UTC' });
        format = format.replace("MMM", shortMonth);
    } else {
        format = format.replace("MM", month.toString().padStart(2, "0"));
    }

    if (format.indexOf("yyyy") > -1) {
        format = format.replace("yyyy", year.toString());
    } else if (format.indexOf("yy") > -1) {
        format = format.replace("yy", year.toString().substr(2, 2));
    }

    if (format.indexOf("HH") > -1) {
        format = format.replace("HH", hour.toString());
    }

    if (format.indexOf("mm") > -1) {
        format = format.replace("mm", minute.toString().padStart(2, "0"));
    }

    if (format.indexOf("tt") > -1) {
        format = format.replace("tt", amOrPm);
    }

    format = format.replace("dd", day.toString().padStart(2, "0"));

    return format;
}
